import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Button } from "./Button";
import MainContent from "./MainContent";
import NewUserInfo from "./NewUserInfo";
import PolicyNotice from "./PolicyNotice";
import ContactHelp from "./ContactHelp";
import { FadeUp } from "./AnimationLibrary";

const Welcome = props => {
	const [accepted, setAccepted] = useState(false);

	if (!props.user || !props.user.netid) return <Redirect push from="/welcome" to="/telluswhoyouare" />;
	if (accepted)	return <Redirect push from="/welcome" to="/setpassword" />;

	return (
		<>
			<MainContent user={props.user} step="1" sideBar={true} showStepProgress={true}>
				<div className="main-message-container">
					<FadeUp delay="0">
						<NewUserInfo user={props.user} />
					</FadeUp>
					<Button onClick={() => setAccepted(true)}>Continue to Set Password</Button>
					<FadeUp delay="250">
						<PolicyNotice />
					</FadeUp>
				</div>
			</MainContent>
			<ContactHelp />
		</>
	);
};

export default Welcome;
